import React from 'react';
import { ClockIcon, ActivityIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-slate-900 relative" data-id="element-109">
      <div className="max-w-4xl mx-auto px-4" data-id="element-110">
        {/* The Hook */}
        <div className="bg-slate-800/50 border border-slate-700/50 rounded-2xl p-8 md:p-12 mb-16 shadow-lg relative overflow-hidden" data-id="element-111">
          <div className="absolute top-0 right-0 p-8 opacity-5 pointer-events-none" data-id="element-112">
            <ClockIcon className="w-48 h-48" data-id="element-113" />
          </div>

          <div className="flex items-center gap-4 mb-6" data-id="element-114">
            <div className="bg-red-500/10 p-3 rounded-lg" data-id="element-115">
              <ClockIcon className="w-8 h-8 text-red-400" data-id="element-116" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-117">
              Son las 3:11 AM.
            </h2>
          </div>

          <p className="text-lg md:text-xl text-slate-300 leading-relaxed mb-6" data-id="element-118">
            Estás mirando el techo, tu cuerpo pesa como el plomo, pero tu mente
            está repasando cada error del pasado y cada pendiente del futuro.
            Sientes ese pequeño nudo de pánico en el pecho porque sabes que en
            pocas horas el despertador va a sonar y tendrás que fingir que eres
            una persona funcional.
          </p>

          <p className="text-lg md:text-xl text-slate-300 leading-relaxed font-medium text-blue-100" data-id="element-119">
            Si estás leyendo esto, es porque la "higiene del sueño" y los tés de
            manzanilla te han fallado. No necesitas más consejos genéricos;
            necesitas un interruptor físico para detener el incendio de cortisol
            en tu sistema nervioso.
          </p>
        </div>

        {/* The Core Problem */}
        <div className="text-center mb-12" data-id="element-120">
          <div className="inline-flex justify-center items-center w-16 h-16 rounded-full bg-blue-500/10 mb-6" data-id="element-121">
            <ActivityIcon className="w-8 h-8 text-blue-400" data-id="element-122" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-123">
            El insomnio moderno no es falta de sueño,
            <br className="hidden md:block" data-id="element-124" />
            <span className="text-blue-400" data-id="element-125">es exceso de alerta.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-126">
          <div className="bg-slate-800 rounded-xl p-8 border border-slate-700" data-id="element-127">
            <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-128">
              <span className="w-2 h-2 rounded-full bg-red-400" data-id="element-129"></span>
              Modo Supervivencia
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-130">
              Tu cerebro cree que estás bajo ataque y ha activado el modo de
              "lucha o huida". Por eso, cuanto más intentas obligarte a dormir,
              más despierto te sientes.
            </p>
          </div>

          <div className="bg-slate-800 rounded-xl p-8 border border-slate-700" data-id="element-131">
            <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-132">
              <span className="w-2 h-2 rounded-full bg-orange-400" data-id="element-133"></span>
              El Ciclo Tóxico
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-134">
              Estás atrapado en un ciclo donde el cansancio extremo genera
              ansiedad, y esa ansiedad bloquea químicamente la melatonina que
              necesitas. Estás pisando el freno y el acelerador al mismo tiempo,
              quemando tu motor mental y emocional cada noche.
            </p>
          </div>
        </div>
      </div>
    </section>;
}